<button id="header-voice-search-0" [class.active]="onSearching" class="mic-wrapper header-voice-search">
  <span class="rec-wrapper animated infinite fadeIn" [hidden]="!onSearching">
    <span class="rec"></span>
  </span>
  <img *ngIf="showContent" class="mic" [src]="src" alt="Mic" />
</button>
